import { Button } from 'antd'
import { twMerge } from "tailwind-merge";

export default function SL_Button(props) {

    const classes = twMerge(`
        flex
        justify-center
        items-center
        text-sm
        rounded
        ${props.className ?? ""}
    `)

    return (
        <Button
            // type="primary"
            {...props}
            
            className={props.shape ? null : classes}
        >
            {props.children}
        </Button>
    )
}
